export const CLUB_SEARCH_RESULT = 'club-search-result';

export const LONDON_CENTER_ZIP = 'EC1A 1AA';

export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const PORTAL_ID = 'CLUB_SEARCH_RESULT';
